import React from 'react';
import './registration.styles.css';
import {
  Form, Grid, Header, Icon, Popup, Input,
} from 'semantic-ui-react';
import FormInputWithInlineError, {
  FormFieldWithInlineError,
} from '../common/FormInputWithInlineError.component';
import CountriesDropDownSelection from '../../utils/CountriesDropdownSelection';
import styles from '../common/FormInputWithInlineError.module.css';
import * as Constants from '../../utils/Constants';
import getEnvironmentName from '../../utils/environment/getEnvironmentName';

const ssnTooltipNote = 'The security of your information is important to us. We ask for your social security'
  + ' number to verify your identity. Mutual of Omaha will never share your personal data.';
const environment = getEnvironmentName();
const RegistrationBegin = ({
  data,
  handleChange,
  showSSN,
  handleSubmit,
  submitting,
}) => (
  <Grid>
    <Grid.Row verticalAlign='middle'>
      <Grid.Column width={2} />
      <Grid.Column width={14}>
        <Header>Register for Access</Header>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={2} />
      <Grid.Column width={14}>
        <p>
          To provide you with the best possible experience, we need to know a
          little more about you.
          <br />
          Please complete the form below.
        </p>
        <br />
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Form>
                <Form.Group>
                  <FormInputWithInlineError
                    fluid
                    label={<>First Name</>}
                    error={data.formErrors.first}
                    name='first'
                    width={6}
                    onChange={handleChange}
                    value={data.first}
                    id='first'
                  />
                  <FormInputWithInlineError
                    fluid
                    label={<>Last Name</>}
                    error={data.formErrors.last}
                    name='last'
                    width={6}
                    onChange={handleChange}
                    value={data.last}
                  />
                </Form.Group>
                <Form.Group>
                  <FormInputWithInlineError
                    fluid
                    label={<>Email Address</>}
                    error={data.formErrors.email}
                    name='email'
                    width={12}
                    onChange={handleChange}
                    value={data.email}
                  />
                </Form.Group>
                <Form.Group>
                  <FormInputWithInlineError
                    width={6}
                    label={(
                      <>
                        Social Security Number&nbsp;
                        <Popup
                          trigger={<Icon name='question circle' />}
                          content={ssnTooltipNote}
                          size='small'
                          className='reg-tooltip'
                        />
                      </>
                    )}
                    error={data.formErrors.ssn}
                    name='ssn'
                    type={data.showingSSN ? 'text' : 'password'}
                    onChange={handleChange}
                    value={data.ssn}
                    maxLength={11}
                    icon={<Icon name='eye' link onClick={showSSN} />}
                  />
                  <FormInputWithInlineError
                    fluid
                    label={<>Date of Birth</>}
                    error={data.formErrors.dateOfBirth}
                    name='dateOfBirth'
                    placeholder='MM/DD/YYYY'
                    width={6}
                    onChange={handleChange}
                    value={data.dateOfBirth}
                    maxLength={10}
                  />
                </Form.Group>
                <Form.Group className={styles.labelMargins}>
                  <label>Phone Number</label>
                </Form.Group>
                <Form.Group>
                  <FormFieldWithInlineError
                    className={styles.countryCode}
                    error={data.formErrors.phone}
                    width='12'
                    children={(
                      <>
                        <CountriesDropDownSelection
                          handleChange={handleChange}
                        />
                        <Input
                          fluid
                          placeholder='(xxx) xxx-xxxx'
                          name='phone'
                          value={data.phone}
                          icon='phone'
                          onChange={handleChange}
                        />
                      </>
                    )}
                  />
                </Form.Group>
                <Form.Button
                  className={`button-submit ${
                    data.errorsExist ? 'disabled' : 'active'
                  }`}
                  loading={submitting}
                  onClick={handleSubmit}
                >
                  Submit
                </Form.Button>
                <Form.Group>
                  <div>
                    Already have an account ?
                    <a href={Constants.userRegistrationURL[environment]}>
                      {' '}
                      Sign in
                      {' '}
                    </a>
                  </div>
                </Form.Group>
              </Form>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);
export default RegistrationBegin;
